import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import appConfig from 'app-config';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication} from '@xengage/gw-digital-auth-react';
import metadata from './MLPhoneTcpaConsentComponent.metadata.json5';
import styles from './MLPhoneTcpaConsentComponent.module.scss';
import './MLPhoneTcpaConsentComponent.messages';

const TAB_BREAKPOINT = 768;

function MLPhoneTcpaConsentComponent(props) {
    const {
        accountContactVM,
        tcpaPhoneConsentVMPath,
        tcpaTextConsentVMPath,
        tcpaConsentSelectionVMPath,
        id,
        showValidationErrors,
        showConsentForm,
        updateConsentForm,
        updateWizardData,
        onValidate,
        updateValueToPath,
        updateTcaConsentSelection
    } = props;
    const [showPopover, updateShowPopover] = useState(showConsentForm);

    const { authUserData } = useAuthentication();
    const { MLUserTypes } = appConfig;

    let isEAorIA = false;
    if (authUserData) {
        isEAorIA = authUserData.userType === MLUserTypes.PCS || authUserData.userType === MLUserTypes.IA;
    }

    const {
        onValidate: setComponentValidation,
        isComponentValid
    } = useValidation(id);

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid]);

    useEffect(() => {
        updateShowPopover(showConsentForm);
    }, [showConsentForm]);

    const hidePanelOnSelect = (value, path) => {
        _.set(accountContactVM, `${path}.value`, value);

        if (_.get(accountContactVM, `${tcpaPhoneConsentVMPath}.value`) !== undefined && _.get(accountContactVM, `${tcpaTextConsentVMPath}.value`) !== undefined) {
            updateShowPopover(false);
            if (updateConsentForm) {
                updateConsentForm(false);
            }
            if(updateTcaConsentSelection){
                updateTcaConsentSelection(true);
            }else{
                _.set(accountContactVM, `${tcpaConsentSelectionVMPath}.value`, true);
            }

            const isMobile = () => {
                return window.innerWidth <= TAB_BREAKPOINT;
            };
            if (isMobile()) {
                const elementHeight = document.getElementById('mlPhoneTcpaConsentRowContainer').clientHeight;
                const scrollPosition = window.pageYOffset - elementHeight;
                window.scrollTo(0, scrollPosition);
            }
        }
        if (updateValueToPath !== undefined) {
            updateValueToPath(value, path);
        } else {
            updateWizardData(accountContactVM);
        }
    };

    const overrideProps = {
        tcpaConsentRadiobutton: {
            id: `${id}-tcpaconsent`,
            path: tcpaPhoneConsentVMPath,
            onValueChange: hidePanelOnSelect
        },
        tcpaTextConsentRadiobutton: {
            id: `${id}-tcpatextconsent`,
            path: tcpaTextConsentVMPath,
            onValueChange: hidePanelOnSelect
        },
        mlPhoneTcpaConsentRowContainer: {
            visible: showPopover && !isEAorIA
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={accountContactVM}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            showErrors={showValidationErrors}
            onValidationChange={setComponentValidation}
        />
    );
}

MLPhoneTcpaConsentComponent.propTypes = {
    accountContactVM: PropTypes.shape({}).isRequired,
    tcpaPhoneConsentVMPath: PropTypes.string.isRequired,
    tcpaTextConsentVMPath: PropTypes.string.isRequired,
    tcpaConsentSelectionVMPath: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    showValidationErrors: PropTypes.bool.isRequired,
    showConsentForm: PropTypes.bool.isRequired,
    updateWizardData: PropTypes.func.isRequired
};

MLPhoneTcpaConsentComponent.defaultProps = {
    updateValueToPath : undefined
};

export default MLPhoneTcpaConsentComponent;
